import { render } from "./NuevaCompraPage.vue?vue&type=template&id=19498e3c&scoped=true"
import script from "./NuevaCompraPage.vue?vue&type=script&lang=js"
export * from "./NuevaCompraPage.vue?vue&type=script&lang=js"

import "./NuevaCompraPage.vue?vue&type=style&index=0&id=19498e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19498e3c"]])

export default __exports__